// @flow
import * as React from "react"
//
import { Layout } from "../components/Layout"
import { tRouteProps } from "../types"
import { css } from "react-emotion/macro"
import { color } from "../styles/variables"
import { Container } from "../components/StyledComponents"

type tNotFound = any

class NotFound extends React.Component<
  tRouteProps & tNotFound,
  {
    ready: boolean,
  },
> {
  state = {
    ready: false,
  }
  componentDidMount() {
    this.makeReady()
  }
  makeReady = () => {
    if (!this.state.ready) {
      this.setState({
        ready: true,
      })
    }
  }
  render() {
    return this.state.ready ? (
      <Container
        className={css`
          padding-top: 60px;
          padding-bottom: 60px;
        `}
      >
        <h1 className="h1-large">404</h1>
        <h2 className="h3">This is not the page you&rsquo;re looking for.</h2>
      </Container>
    ) : null
  }
}

function RenderNotFound(props: tNotFound) {
  return (
    <Layout
      css={css`
        background-color: black;

        main {
          padding: 20% 0;
          text-align: center;
        }

        h1,
        h2,
        h3 {
          color: ${color.rgb.purple[1]};
        }
      `}
    >
      {(routeProps) => <NotFound {...props} {...routeProps} />}
    </Layout>
  )
}

export default RenderNotFound



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/NotFound.js